export default {
  setUsersMetadata(state, users) {
    state.users = users
  },
  setSingleSetting(state, payload) {
    const target = payload.funeralHomeId
      ? state.initialMetadata.fh_settings[payload.funeralHomeId]
      : state.initialMetadata.settings

    const current = target[payload.setting]
    const isPlainObject = (v) =>
      v !== null && typeof v === 'object' && !Array.isArray(v)

    if (isPlainObject(current) && isPlainObject(payload.values)) {
      // Mutate in place so Vue tracks nested property changes reactively
      Object.keys(current).forEach((key) => {
        if (!(key in payload.values)) delete current[key]
      })
      Object.assign(current, payload.values)
    } else {
      target[payload.setting] = payload.values
    }
  },
  setAllMetadata(state, data) {
    state.users = [...data.users]
  },
  setInitialMetadata(state, initialMetadata) {
    state.initialMetadata = initialMetadata
    // console.log('%c✔ metadata loaded ', 'color: #648d3d')
    state.loaded = true
  },
  resetState(state, initialState) {
    state.loaded = false
    state.initialMetadata = { ...initialState.initialMetadata }
  },
  setMetadataModels(state, models) {
    state.initialMetadata.models = models
  },
  setSpecificMetadataModels(state, payload) {
    state.initialMetadata.models[payload.model] = payload.data
  },
  setMetadataSettings(state, payload) {
    state.initialMetadata.settings = payload.settings
    state.initialMetadata.fh_settings = payload.fh_settings
  },
  setMutlipleMetadataModels(state, payload) {
    let modelNames = Object.keys(payload)
    modelNames.forEach((modelName) => {
      state.initialMetadata.models[modelName] = payload[modelName]
    })
  },
  setMainKey(state, payload) {
    state.mainKey = payload
  },
  incrementMainKey(state) {
    // console.log('mainKey', state.mainKey)
    state.mainKey = state.mainKey + 1
  },
  toggleModalVersionNote(state, status) {
    state.openModalVersionNote = status
  },
  updateFormConfigSettings(state, newFormValue) {
    state.global_form.current_form_settings = newFormValue
  },
  updateFormConfigFuneralHomeId(state, id) {
    state.global_form.funeral_home_id = id
  },
  toggleGlobalFormEditionMode(state, status) {
    state.global_form.edition_mode =
      status !== undefined ? status : !state.global_form.edition_mode
  },
  toggleFormConfigSection(state, { pageKey, sectionKey }) {
    if (!state.global_form.current_form_settings) return
    if (!state.global_form.current_form_settings.sections) {
      state.global_form.current_form_settings.sections = {}
    }
    const hidden =
      state.global_form.current_form_settings.sections[pageKey] ?? []
    state.global_form.current_form_settings.sections[pageKey] = hidden.includes(
      sectionKey
    )
      ? hidden.filter((key) => key !== sectionKey)
      : [...hidden, sectionKey]
  },

  updateUserInMetadata(state, user) {
    ;['users', 'all_users'].forEach((listKey) => {
      const list = state.initialMetadata.models[listKey]
      if (!Array.isArray(list)) return
      const index = list.findIndex((u) => u.id === user.id)
      if (index !== -1) {
        list[index] = { ...list[index], ...user }
      }
    })
  },

  //  USER STATUS
  changeUserOnlineStatus(state, payload) {
    const index = state.initialMetadata.models.all_users.findIndex(
      (user) => user.id === payload.user_id
    )
    if (index !== -1) {
      state.initialMetadata.models.all_users[index] = {
        ...state.initialMetadata.models.all_users[index],
        online: payload.online
      }
    }
  }
}
